import {
    Code,
    Text,
} from '@mantine/core';

import {useApplicationName} from '../hooks/useApplicationOptions';

// FNP-979. Renders the NAME of a referenced console-api `Application`.
//
// ⚠️ THIS IS A COMPONENT, NOT A HELPER FUNCTION, on purpose: resolving the name
// needs a hook, and a table column's `render` callback is not a component body —
// calling a hook from there breaks the rules of hooks. Every cell subscribes to
// the same cached query, so this is one request for the whole table.
//
// Falls back to the raw id when the application cannot be resolved (archived, or
// not visible to this operator). Showing the id — rather than blank — keeps a
// dangling reference VISIBLE: an empty cell reads as "no application", which is
// a different and misleading fact.
export const ApplicationName = ({applicationId}: { applicationId?: string | null }) => {

    const name = useApplicationName(applicationId);

    if (!name) {
        return <Text size={'sm'} c={'dimmed'}>n/a</Text>;
    }

    // Unresolved: the value we are showing IS the raw id, so it is rendered as a
    // code token to make clear it is an identifier rather than a name.
    if (name === applicationId) {
        return <Code>{applicationId}</Code>;
    }

    return <>{name}</>;
};
